module.exports = __webpack_public_path__ + "img/FallaVentilador.c9fcc253.svg";